import { ApiError } from './ApiError.js';
import { HTTP_STATUS } from './constants.js';

const fetcher = async (url, {
  body,
  headers = {},
  method
} = {}) => {
  let usedMethod = method;
  const isFormData = body instanceof FormData;
  if (!method) {
    usedMethod = body ? 'POST' : 'GET';
  }
  const response = await fetch(url, {
    body: isFormData ? body : JSON.stringify(body),
    headers: {
      ...(isFormData ? {} : {
        'Content-Type': 'application/json'
      }),
      ...headers
    },
    method: usedMethod
  });
  if (!response.ok) {
    const data = await response.text();
    let error;
    try {
      const errorData = JSON.parse(data);
      error = new ApiError(response.status, errorData.message);
    } catch {
      error = new ApiError(response.status, data);
    }
    throw error;
  }
  let responseData;
  try {
    responseData = await response.text();
    return JSON.parse(responseData);
  } catch {
    return responseData;
  }
};
const mutationFetcher = async (url, {
  arg
}) => {
  let body;
  const headers = {
    'Content-Type': 'application/json',
    ...arg.headers
  };
  if ('body' in arg) {
    if (arg.asFormData) {
      body = new FormData();
      for (const key in arg.body) {
        if (typeof arg.body[String(key)] !== 'undefined') {
          if (arg.body[String(key)][0] instanceof File) {
            const files = Array.from(arg.body[String(key)]);
            files.forEach(file => body.append(key, file));
          } else {
            body.append(key, arg.body[String(key)]);
          }
        }
      }
    } else {
      body = JSON.stringify(arg.body);
    }
  }
  if (arg.asFormData) {
    delete headers['Content-Type'];
  }
  const response = await fetch(url, {
    body,
    headers,
    method: 'method' in arg ? arg.method : 'GET'
  });
  if (!response.ok) {
    const data = await response.text();
    let error;
    try {
      const errorData = JSON.parse(data);
      error = new ApiError(response.status, errorData.message);
    } catch {
      error = new ApiError(response.status, data);
    }
    throw error;
  }
  if (response.status === HTTP_STATUS.NO_CONTENT) {
    return null;
  }
  let responseData;
  try {
    responseData = await response.text();
    return JSON.parse(responseData);
  } catch {
    return responseData;
  }
};

export { fetcher, mutationFetcher };
//# sourceMappingURL=fetchers.js.map
